<script type="ts">
	let className = ''
	export { className as class }
</script>

<!-- note-2.svg -->
<svg
	class="stroke-current h-5 w-5 {className} "
	width="21"
	height="21"
	viewBox="0 0 21 21"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M18.9527 9.13501L18.0952 12.7925C17.3602 15.9513 15.9077 17.2288 13.1777 16.9663C12.7402 16.9313 12.2677 16.8525 11.7602 16.73L10.2902 16.38C6.64141 15.5138 5.51266 13.7113 6.37016 10.0538L7.22766 6.38751C7.40266 5.64376 7.61266 4.99626 7.87516 4.46251C8.89891 2.34501 10.6402 1.77626 13.5627 2.46751L15.0239 2.80876C18.6902 3.66626 19.8102 5.47751 18.9527 9.13501Z"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M13.1776 16.9662C12.6351 17.3337 11.9526 17.64 11.1213 17.9112L9.7388 18.3662C6.26505 19.4862 4.4363 18.55 3.30755 15.0762L2.18755 11.62C1.06755 8.14621 1.99505 6.30871 5.4688 5.18871L6.8513 4.73371C7.21005 4.61996 7.5513 4.52371 7.87505 4.46246C7.61255 4.99621 7.40255 5.64371 7.22755 6.38746L6.37005 10.0537C5.51255 13.7112 6.6413 15.5137 10.2901 16.38L11.7601 16.73C12.2676 16.8525 12.7401 16.9312 13.1776 16.9662Z"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M11.0601 7.46375L15.3038 8.54"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.2026 10.85L12.7401 11.4975"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
